(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var scrim = document.getElementById('cart-scrim');
    var drawer = document.getElementById('cart-drawer');
    var closeBtn = document.getElementById('cart-close');
    var FREE_SHIPPING = 15000;
    function openDrawer() { scrim.classList.add('is-open'); drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function closeDrawer() { scrim.classList.remove('is-open'); drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    document.querySelectorAll('[data-cart-toggle]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    function updateShippingBar() {
      var fill = document.getElementById('cart-shipping-fill');
      var msg = document.getElementById('cart-shipping-msg');
      if (!fill || !msg) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var total = cart.total_price;
        var pct = Math.min(100, (total / FREE_SHIPPING) * 100);
        fill.style.width = pct + '%';
        var left = Math.max(0, FREE_SHIPPING - total);
        if (left > 0) { var formatted = (left / 100).toFixed(2).replace('.', ',') + ' €'; msg.innerHTML = '<b>Te faltan ' + formatted + '</b> para el envío gratis'; }
        else { msg.innerHTML = '<b>¡Envío gratis conseguido!</b>'; }
      });
    }
    updateShippingBar();
    document.addEventListener('cart:updated', function () {
      updateShippingBar();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var subtotalEl = document.getElementById('cart-subtotal');
        var totalEl = document.getElementById('cart-total');
        var countEls = document.querySelectorAll('.header__cart-count');
        if (subtotalEl) subtotalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
        if (totalEl) totalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        openDrawer();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-card__add-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.dataset.productId;
        if (!id) return;

        btn.disabled = true;
        btn.textContent = '...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '\u2713';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = btn.getAttribute('aria-label');
          }, 1200);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('aria-label');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var y = target.getBoundingClientRect().top + window.pageYOffset - 76;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var mainImg = document.getElementById('pdp-main-img');
    var thumbs = mainImg ? Array.prototype.slice.call(document.querySelectorAll('.pdp__thumb')) : [];
    var urls = thumbs.length ? thumbs.map(function (t) { return t.getAttribute('data-full'); }) : (mainImg ? [mainImg.src] : []);
    var cur = 0;
    function showMain(i) {
      if (!mainImg || i < 0 || i >= urls.length) return;
      cur = i; mainImg.removeAttribute('srcset'); mainImg.src = urls[i];
      thumbs.forEach(function (x) { x.classList.remove('is-on'); });
      if (thumbs[i]) { thumbs[i].classList.add('is-on'); thumbs[i].scrollIntoView({ block: 'nearest', inline: 'center' }); }
    }
    function showByImageId(id) {
      if (!id) return false;
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].getAttribute('data-img-id') === id) { showMain(i); return true; } }
      return false;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showMain(i); }); });

    var swiped = false;
    var mainEl = document.querySelector('.pdp__main');
    if (mainEl && urls.length > 1) {
      var sx = 0;
      mainEl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      mainEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { swiped = true; showMain((cur + (dx < 0 ? 1 : -1) + urls.length) % urls.length); setTimeout(function () { swiped = false; }, 80); }
      }, { passive: true });
    }

    var lb = document.getElementById('pdp-lightbox');
    var lbImg = document.getElementById('pdp-lb-img');
    var mainBtn = document.getElementById('pdp-main-btn');
    function openLb() { if (!lb) return; lbImg.src = urls[cur]; lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function closeLb() { if (!lb) return; lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    function go(d) { var i = (cur + d + urls.length) % urls.length; showMain(i); lbImg.src = urls[i]; }
    if (mainBtn) mainBtn.addEventListener('click', function () { if (swiped) return; openLb(); });
    var c = document.getElementById('pdp-lb-close'); if (c) c.addEventListener('click', closeLb);
    var pv = document.getElementById('pdp-lb-prev'); if (pv) pv.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    var nx = document.getElementById('pdp-lb-next'); if (nx) nx.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) { if (!lb || !lb.classList.contains('is-open')) return; if (e.key === 'Escape') closeLb(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1); });

    var form = document.getElementById('pdp-form');
    if (form) {
      var select = document.getElementById('pdp-variant-select');
      var priceEl = document.getElementById('pdp-price');
      var addBtn = document.getElementById('pdp-add-btn');
      var groups = form.querySelectorAll('.pdp__chips');
      function update() {
        var chosen = [];
        groups.forEach(function (g) { var on = g.querySelector('.pdp__chip.is-on'); if (on) chosen.push(on.getAttribute('data-value')); });
        var key = chosen.join(' / ');
        var opts = select.options;
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].getAttribute('data-options') === key) {
            select.selectedIndex = i;
            var p = opts[i].getAttribute('data-price');
            var cmp = opts[i].getAttribute('data-compare');
            var os = opts[i].getAttribute('data-onsale') === '1';
            if (priceEl && p) { priceEl.innerHTML = (os ? '<s class="pdp__was">' + cmp + '</s> ' : '') + '<span class="pdp__now">' + p + '</span>' + (os ? ' <span class="pdp__sale-tag">Rebajas</span>' : ''); }
            showByImageId(opts[i].getAttribute('data-image'));
            var av = opts[i].getAttribute('data-available');
            if (addBtn) { if (av === 'false') { addBtn.setAttribute('disabled', ''); addBtn.textContent = 'Agotado'; } else { addBtn.removeAttribute('disabled'); addBtn.textContent = 'Añadir a la cesta'; } }
            break;
          }
        }
      }
      groups.forEach(function (g) {
        g.querySelectorAll('.pdp__chip').forEach(function (chip) {
          chip.addEventListener('click', function () {
            g.querySelectorAll('.pdp__chip').forEach(function (c) { c.classList.remove('is-on'); });
            chip.classList.add('is-on'); update();
          });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
